export default (product, filter) => (filter ? product.get('isExclusive') : true);